import { useRouter } from "next/router"
import dynamic from "next/dynamic"
import { InferGetStaticPropsType } from "next"
import { fetchApp } from "queries"

const AR = dynamic(() => import("views/articles/BestQuranApps/ar"))
const TR = dynamic(() => import("views/articles/BestQuranApps/tr"))
const EN = dynamic(() => import("views/articles/BestQuranApps/en"))

const mainApps = ["706037876", "385990290", "328962407"]

const BestNoteTakingApps = ({
  apps,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const router = useRouter()
  if (router.locale === "ar") return <AR apps={apps} />
  if (router.locale === "tr-TR") return <TR apps={apps} />
  return <EN apps={apps} />
}

export default BestNoteTakingApps

export const getStaticProps = async () => {
  const apps = (
    await Promise.allSettled(mainApps.map((app) => fetchApp(app)))
  ).map((item: any) => ({
    trackId: item?.value?.trackId,
    artworkUrl512: item?.value?.artworkUrl512,
    trackName: item?.value?.trackName,
    genres: item?.value?.genres,
    description: item?.value?.description.slice(0, 50) + "...",
    formattedPrice: item?.value?.formattedPrice,
    submitterPrice: item?.value?.submitterPrice,
    price: item?.value?.price,
    submitter: item?.value?.submitters?.[0],
    appRemoved: item?.value?.appRemoved,
    hasInAppPurchases: item?.value?.hasInAppPurchases,
  }))

  return {
    props: {
      apps: JSON.parse(JSON.stringify(apps)),
    },
  }
}
